import styled from 'styled-components';

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 16px;
  border-radius: 16px;
  margin: 16px;

  @media (min-width: 768px) {
    margin: 32px;
  }
`;